import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { Navigate } from "react-router-dom";
import { AppRouting, getPath } from "Infrastructure/Utils/UrlUtils";
import { ErrorBoundary } from "react-error-boundary";
import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";

type Props = {
  requiredAccessRights?: string[];
};

export const AuthenticatedRoute: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  requiredAccessRights,
}) => {
  const { data, isLoading } = useUserInfoQuery();

  if (isLoading) return <div />;

  if (data?.status === 401) {
    return <Navigate to={getPath(AppRouting.SignIn)} replace />;
  }

  if (requiredAccessRights && requiredAccessRights.length > 0 && data?.status === 200) {
    const userAccessRights = data.data.accessRightCodes ?? [];
    const hasAccess = requiredAccessRights.some((right) =>
      userAccessRights.includes(right)
    );

    if (!hasAccess) {
      return <Navigate to={getPath(AppRouting.Error403)} replace />;
    }
  }

  return (
    <ErrorBoundary FallbackComponent={ApplicationErrorPage}>
      {children}
    </ErrorBoundary>
  );
};
